import script from "./ResponseFactor.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponseFactor.vue?vue&type=script&setup=true&lang=js"

import "./ResponseFactor.vue?vue&type=style&index=0&id=2a290386&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a290386"]])

export default __exports__